
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';


const StyledButton = styled(Button)`
  background-color: #FEC108 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
`;


export class YellowButton extends Component {
  render() {
    const { loading, ...otherProps } = this.props;
    return (
      <StyledButton {...otherProps}>
        {this.props.children}
      </StyledButton>
    )
  }
}
